import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Textfit } from 'react-textfit';
import AudioIcon from '../assets/audio-icon.png'
import Background from "../../auth/styled_components/Background";
import useSpeech from "../hooks/useSpeech"

var selectedAnswer = -1;
var currQuestion = undefined;

export default function MultipleChoice({ currentQuestion, ...props }) {
  //const { sayWord } = useSpeech();
  if (currQuestion != currentQuestion){
    currQuestion = currentQuestion;
    selectedAnswer = -1;
  }

  //Called on click
  async function Toggle(value) {
    selectedAnswer = value;
    console.log("Selected: " + selectedAnswer)
    sayWord(currentQuestion.answers[value].audio);
    //play sound
  }

  function sayWord(word){
    if (word != undefined && word != ""){
    if(word.includes("x.png")){
        word = word.replace("x.png", "");
	}
    else if(word.includes(".png")){
        word = word.replace(".png", "");
	}
      console.log("playing sound: " + word);
       var audio = new Audio("/audio/" + word + '.mp3'); 
      audio.play();
      }
  }

  function ReturnButton(value) {

    if (currentQuestion.answers[value].image == null){
      if (value == selectedAnswer) {
        return (
          <SelectedButton
            value={currentQuestion.answers[value].value}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => Toggle(value)}
          >
            <img style={{ position: "relative", top: "15%" }} src={AudioIcon} />
          </SelectedButton>
        );
      } else {
        return (
          <Button
            value={currentQuestion.answers[value].value}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => Toggle(value)}
          >
            <img style={{ position: "relative", top: "15%" }} src={AudioIcon} />
          </Button>
        );
      }
    }else{//NEW IMAGE QUESTIONS
      if (value == selectedAnswer) {
        return (
          <SelectedButton
            value={currentQuestion.question}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => Toggle(value)}
          >
            <img style={{ position: "relative", top: "15%" ,width: "90px" }} src={`/qimages/phonics/${currentQuestion.answers[value].image}`} />
          </SelectedButton>
        );
      } else {
        return (
          <Button
            value={currentQuestion.question}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => Toggle(value)}
          >
            <img style={{ position: "relative", top: "15%",width: "90px" }} src={`/qimages/phonics/${currentQuestion.answers[value].image}`} />
          </Button>
        );
      }
    }
  }

  function ReturnFeedbackButton(value) {

    if (currentQuestion.answers[value].image == null){
    return (
        <Button
          value={currentQuestion.answers[value].value}
          style={{ flex: 1, margin: "20px" , ...(currentQuestion.answers[value].correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
        >
          <span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.answers[value].value) }} />}</span>
        </Button>
      );
    }else{
      return(
      <Button
          value={currentQuestion.answers[value].value}
          style={{ flex: 1, margin: "20px" , ...(currentQuestion.answers[value].correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
        >
          <img style={{ position: "relative", top: "15%",width: "90px" }} src={`/qimages/phonics/${currentQuestion.answers[value].image}`} />
        </Button>);
    }
    
  }

  return (
    <>
      <Container>
        <div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Question
              type="text"
              disabled
              value={
                currentQuestion.question !== undefined
                  ? currentQuestion.question.replace("$", "?")
                  : ""
              }
            >
              <Textfit mode="multi" max="50" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question) }} />}</span></Textfit></Question>
          </div>
          {currentQuestion.question2 !== undefined && currentQuestion.question2 !== "" ?
            <Question
              type="text"
              disabled
              value={
                currentQuestion.question2 !== undefined
                  ? currentQuestion.question2.replace("$", "?")
                  : ""
              }
            ><Textfit mode="multi" max="40" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question2) }} />}</span></Textfit></Question>
            : ""}
        </div>
        {props.onShowFeedback == false && currentQuestion.answers !== undefined ? (
          <div>
            <div
              selected={selectedAnswer}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              {ReturnButton(0)}
              {ReturnButton(1)}
            </div></div>) : ""}

            {props.onShowFeedback == true && currentQuestion.answers !== undefined ? (
          <div>
            <div
              selected={selectedAnswer}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              {ReturnFeedbackButton(0)}
              {ReturnFeedbackButton(1)}
            </div></div>) : ""}

        <LongButton
          style={{ alignSelf: "center", flex: 1, margin: "20px" }}
          onClick={() => props.onSubmit(currentQuestion.answers[selectedAnswer], currentQuestion)}
        >
          <span>Submit</span>
        </LongButton>
      </Container>
    </>
  );
}

const Container = styled.div`
width:80%;
height:95%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom:100px;
`;

const Question = styled.div`
  background: #FFF;
  user-select: none;
  width: 100%;
  height: 120px;
  line-height: 90px;
  font-size: 4em;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
`;

const Button = styled.div`
  text-align: center;
  width: 10%;
  height: 150px;
  line-height: 100px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const LongButton = styled.div`
  text-align: center;
  width: 80%;
  height: 100px;
  line-height: 50px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const SelectedButton = styled.div`
text-align: center;
width: 10%;
height: 150px;
line-height: 100px;
font-size: 4em;
margin: 5px;
color: #fff;
user-select: none;
background: rgb(234, 146, 19);
background: linear-gradient(
  0deg,
  rgba(45, 168, 35, 1) 0%,
  rgba(36, 138, 29, 1) 100%
);
border: 2px solid #e88f12;
padding: 0.5em;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 1025px) and (max-width: 1440px) {
  font-size: 2.5em;
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

